import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    Button
} from "antd";
import cx from "classnames";
import { SINGLE_ADHOC_FORM_FIELDS } from "constants/form-fields";
import { fieldGenerator, getErrorOnField, submitForm } from "utilities/form";
import "styles/form.css";

class CaseAdhocForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(
        this.props.form,
        (values) =>
            this.props.onFormSubmit(values)
    );

    render() {
        return (
            <Form
                layout={"vertical"}
                className={cx("form-vertical", "f-grow-1", "br-3")}
                onSubmit={this.handleFormSubmit}
            >
                {SINGLE_ADHOC_FORM_FIELDS.map((field, fieldName) => {
                    if(fieldName === "bank_code" && this.props.lending_partners) {
                        field.options = this.props.lending_partners.map(_ => ({
                            label: _.code,
                            value: _.code
                        }));
                    }
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getErrorOnField(fieldName)
                    )();
                })
                    .toList()
                    .toJS()}
                <Form.Item>
                    <div className={"d-flex justify-content-flex-end"}>
                        <Button type="primary" htmlType="submit">
                            Create
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        );
    }
}

CaseAdhocForm.propTypes = {
    form: PropTypes.object,
    lending_partners: PropTypes.array,
    onFormSubmit: PropTypes.func
};

export default Form.create({})(CaseAdhocForm);